import { Component, OnInit } from '@angular/core';
import { AngularGridInstance, Column, GridOption } from 'angular-slickgrid';
import { MessageService } from '../message.service';

@Component({
  selector: 'app-common-slickgrid',
  templateUrl: './common-slickgrid.component.html',
  styleUrls: ['./common-slickgrid.component.css']
})
export class CommonSlickgridComponent implements OnInit {

  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset = [];
  angularGrid: AngularGridInstance;
  totalData: number;
  selectedTitles: any[];
  gridObj: any;
  gridWidth: number;
  isDisplay: boolean;

  constructor(private messageService: MessageService) {
    this.messageService.getColumnDefinitions().subscribe(rawData => {
      // console.log('getColumnDefinitions');
      this.columnDefinitions = rawData;
    });
    this.messageService.getGridData().subscribe(gridData => {
      console.log('getGridData:+' + JSON.stringify(gridData));
      this.dataset = gridData;
    });
    this.messageService.getRow().subscribe(row => {
      // console.log(JSON.stringify(row));
      this.angularGrid.gridService.addItemToDatagrid(row, false);
    });
    this.messageService.getGridWidth().subscribe(width => {
      // console.log('getGridData:+' + JSON.stringify(gridData));
      this.gridWidth = width;
    });
    this.messageService.getAfterDelete().subscribe(id => {
      // console.log('getAfterDelete:+' + JSON.stringify(id));
      this.angularGrid.gridService.deleteDataGridItemById(id);
    });

  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
    const classes = document.getElementsByClassName('search-filter');
    for (let i = 0; i < classes.length; i++) {
      classes[i].setAttribute('placeholder', '');
    }
    this.gridObj.onBeforeEditCell.subscribe((e, args) => {
      // this.messageService.setBeforeChangeData(args);

      if (args.item.seq !== 1 && args.item.type === 'ClientTicket') {
        // console.log('invalid');
        return false;
      }
    });
  }

  ngOnInit() {
    this.isDisplay = false;
    setTimeout(() => {
      this.isDisplay = true;

    }, 0);
    this.gridOptions = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: true,
      enableRowSelection: true,
    };
    this.dataset = [];
  }


  onCellChanged(e, args) {
    // console.log(JSON.stringify(args));
    args.item.type = 'change';
    this.messageService.setCellChangeData(args.item);
  }

  handleSelectedRowsChanged(e, args) {
    if (Array.isArray(args.rows)) {
      this.selectedTitles = args.rows.map(idx => {
        const item = this.gridObj.getDataItem(idx);
        return item || '';
      });
      this.messageService.setSelectedItemData(this.selectedTitles);
      console.log(JSON.stringify(this.selectedTitles));
    }
  }

  onCellClicked(e, args) {
    const metadata = this.angularGrid.gridService.getColumnFromEventArguments(args);
    // console.log(metadata);

    if (metadata.columnDef.id === 'delete') {
      // console.log(JSON.stringify(metadata.columnDef));
      // console.log(JSON.stringify(metadata.dataContext));
      metadata.dataContext.type = 'delete';
      this.messageService.setCellChangeData(metadata.dataContext);
    } else {
      metadata.dataContext.type = 'showTicket';
      this.messageService.setCellChangeData(metadata.dataContext);
    }
  }
}
